module.exports = __webpack_public_path__ + "static/img/data1-list1.bfbe3f6a.png";